import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { id: "heading-saved-challenges" }, "Saved challenges", -1)
const _hoisted_3 = { class: "flex justify-end my-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, " New challenge ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, " Add new ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Ribbon = _resolveComponent("Ribbon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_GuidedTour = _resolveComponent("GuidedTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentBlock, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Editorial, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppButtonRouterLink, {
              id: "new-challenge",
              type: "primary",
              to: { name: 'challenges-new' }
            }, {
              iconAfter: _withCtx(() => [
                _createVNode(_component_ArrowRightIcon, { class: "ml-2 stroke-current stroke-2" })
              ]),
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Ribbon, { "ribbon-type": "grey" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tabs, {
          "active-tab": _ctx.activeTab,
          "uses-router": true,
          "has-content": false,
          tabs: _ctx.tabs,
          "tab-type": "underlined"
        }, null, 8, ["active-tab", "tabs"])
      ]),
      _: 1
    }),
    _createVNode(_component_ContentBlock, { class: "mb-20" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    _createVNode(_component_GuidedTour, { name: "saved-challenges" })
  ], 64))
}